"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opadeStudy = void 0;
const cognito_1 = require("../../../model/cognito");
const types_and_constants_1 = require("../../../model/data-collection/types-and-constants");
const diseases_1 = require("../../../model/diseases");
const languages_1 = require("../../../model/languages");
const lock_1 = require("../../../model/lock/lock");
const pages_1 = require("../../../model/pages");
const deployment_environments_1 = require("../../deployment-environments");
exports.opadeStudy = {
    diseaseType: diseases_1.DiseaseType.STUDY,
    disease: diseases_1.Disease.OPADE,
    homePage: pages_1.FrontendPageEnum.CHAT,
    theme: {
        daisyTheme: {
            primary: "#3ca66a",
            "primary-focus": "#34915d",
            "primary-content": "#FFFFFF",
            secondary: "#88a9e3",
            "secondary-focus": "#7895c8",
            "secondary-content": "#FFFFFF",
            accent: "#3459A3",
            "accent-focus": "#2D4D8C",
            "accent-content": "#FFFFFF",
            neutral: "#424242",
            "neutral-focus": "#333333",
            "neutral-content": "#FFFFFF",
            "base-100": "#ffffff",
            "base-200": "#f0f0f0",
            "base-300": "#e0e0e0",
            "base-content": "#1f1f1f",
            info: "#25dbf1",
            "info-content": "#082f34",
            success: "#30ca6b",
            "success-content": "#14522a",
            warning: "#dec762",
            "warning-content": "#524b2b",
            error: "#ff4d4d",
            "error-content": "#ffffff",
            "--btn-text-case": "none",
        },
        extendedTheme: {
            colors: {
                mamaAskUserChatBubble: "#43d178",
                mamaAnswerUserChatBubble: "#1f3560",
            },
        },
    },
    supportedLanguages: [
        languages_1.Language.en_US,
        languages_1.Language.it_IT,
        languages_1.Language.es_ES,
        languages_1.Language.tr_TR,
    ],
    publicPages: [],
    enabledPages: [
        Object.assign({ txPageName: "chat", route: pages_1.FrontendPageEnum.CHAT, groupsWhichCanSeeThePage: [cognito_1.SupportedGroupsEnum.USER], settings: {
                chatType: pages_1.ChatType.LANDBOT,
                defaultLandbotUrlTx: "tenant.opade.defaultLandbotUrl",
            } }, lock_1.defaultPageLock),
        Object.assign({ txPageName: "home", route: "/home", groupsWhichCanSeeThePage: [
                cognito_1.SupportedGroupsEnum.USER,
                cognito_1.SupportedGroupsEnum.ADMIN,
            ] }, lock_1.defaultPageLock),
        Object.assign({ txPageName: "journey", route: pages_1.FrontendPageEnum.JOURNEY, groupsWhichCanSeeThePage: [cognito_1.SupportedGroupsEnum.USER] }, lock_1.defaultPageLock),
    ],
    showCallSupportButton: {
        telephoneNumberTx: "disease.opade.settings.supportNumber",
    },
    authLogo: "/resources/major-depressive-disorder/opade/opade-logo.png",
    headerLogo: "/resources/major-depressive-disorder/opade/opade-logo.png",
    narrowHeaderLogo: "/resources/major-depressive-disorder/opade/opade-favicon.png",
    favIcon: "/resources/major-depressive-disorder/opade/opade-favicon.png",
    favIconHighres: "/resources/major-depressive-disorder/opade/opade-favicon.png",
    tenantNameTx: "disease.opade.settings.name",
    autoConfirmUsers: false,
    groupSecretsArns: {
        [deployment_environments_1.DeploymentEnvironment.DEV]: "arn:aws:secretsmanager:eu-central-1:616427543840:secret:group-secrets-opade-jCg5oq",
        [deployment_environments_1.DeploymentEnvironment.PROD]: "arn:aws:secretsmanager:eu-central-1:025928572003:secret:group-secrets-opade-hRt5wW",
    },
    identityProviders: [],
    metaDescriptionTx: "disease.opade.settings.description",
    organisations: [],
    dataGuardConfig: [
        {
            title: "dataGuards.legal.title",
            dataGuardInputs: [
                { inputFor: types_and_constants_1.DataToBeCollectedEnum.PRIVACY_POLICY_2023_10_18 },
                { inputFor: types_and_constants_1.DataToBeCollectedEnum.TERMS_AND_CONDITIONS_2023_08_30 },
            ],
        },
        {
            title: "dataGuards.socialDemographics.title",
            dataGuardInputs: [
                { inputFor: types_and_constants_1.DataToBeCollectedEnum.OPADE_PATIENT_ID },
                { inputFor: types_and_constants_1.DataToBeCollectedEnum.NAME },
                { inputFor: types_and_constants_1.DataToBeCollectedEnum.YEAR_OF_BIRTH },
                {
                    inputFor: types_and_constants_1.DataToBeCollectedEnum.GENDER,
                    reasonWhyShown: "userData.biologicalSexNote",
                },
                { inputFor: types_and_constants_1.DataToBeCollectedEnum.COUNTRY },
                { inputFor: types_and_constants_1.DataToBeCollectedEnum.POSTAL_CODE },
                {
                    inputFor: types_and_constants_1.DataToBeCollectedEnum.ACQUISITION_DETAIL,
                    isOptional: true,
                },
                {
                    inputFor: types_and_constants_1.DataToBeCollectedEnum.PHONE_NUMBER,
                    reasonWhyShown: "userData.telephoneNote",
                    isOptional: true,
                },
            ],
        },
    ],
    partners: [
        { image: "/resources/funded-by-the-eu-en.png", language: languages_1.Language.en_US },
        { image: "/resources/funded-by-the-eu-es.png", language: languages_1.Language.es_ES },
        { image: "/resources/funded-by-the-eu-it.png", language: languages_1.Language.it_IT },
        { image: "/resources/funded-by-the-eu-tr.png", language: languages_1.Language.tr_TR },
    ],
    userFeedback: [],
    profileInputs: [
        types_and_constants_1.DataToBeCollectedEnum.NAME,
        types_and_constants_1.DataToBeCollectedEnum.EMAIL,
        types_and_constants_1.DataToBeCollectedEnum.OPADE_PATIENT_ID,
        types_and_constants_1.DataToBeCollectedEnum.COUNTRY,
        types_and_constants_1.DataToBeCollectedEnum.LANGUAGE,
    ],
    hideTutorial: true,
    onboardingType: "chat",
};
